import {Button, Col, Form, Input, Row, Space, Spin, Typography} from "antd";
import {shoppingService} from "api";
import {Notification} from "components/common";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import {TRANG_THAI_MUA_SAM} from "types/enums/shopping";
const css = {xs: 24, sm: 24, md: 24, lg: 12, xl: 12};
const {xs, sm, md, xl, lg} = css;
const ModalApprove = forwardRef((props: any, ref) => {
  const {selectedRowKeys, getData, trangThai, closeModal} = props;
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const [roleNguoiDuyet, setRoleNguoiDuyet] = useState<any>("");
  useImperativeHandle(ref, () => ({
    resetFields: () => {
      form.setFieldValue("nguoiDuyet", null);
    },
  }));
  const submitApprove = async () => {
    try {
      const formValues = await getFormValues();
      if (formValues) {
        setIsLoading(true);
        const data = {
          listId: selectedRowKeys,
          nguoiDuyet: formValues?.nguoiDuyet,
        };
        await shoppingService.approveListProposeShopping(data);
        setIsLoading(false);
        getData();
        closeModal();
      }
    } catch (error) {
      setIsLoading(false);
      Notification("error", error?.response?.data ?? "Đã có lỗi");
    }
  };
  const getFormValues = async () => {
    try {
      const formValues = await form.validateFields();
      return formValues;
    } catch (error) {
      return null;
    }
  };
  useEffect(() => {
    const _setRoleNguoiDuyet = trangThai => {
      let _rolenguoiDuyet = "";
      switch (trangThai) {
        case TRANG_THAI_MUA_SAM.CHO_DUYET:
          _rolenguoiDuyet = "Kế toán";
          break;
        case TRANG_THAI_MUA_SAM.TRUONG_BP_DA_DUYET:
          _rolenguoiDuyet = "Ban Giám đốc";
          break;
        case TRANG_THAI_MUA_SAM.KE_TOAN_DA_DUYET:
          _rolenguoiDuyet = "";
          break;
        default:
          break;
      }
      setRoleNguoiDuyet(_rolenguoiDuyet);
    };
    _setRoleNguoiDuyet(trangThai);
  }, [trangThai]);
  return (
    <Spin spinning={isLoading}>
      <>
        {trangThai != TRANG_THAI_MUA_SAM.KE_TOAN_DA_DUYET ? (
          <Form form={form} style={{marginTop: 15}}>
            <Space direction="vertical" style={{width: "100%"}}>
              <Typography.Text strong>
                Chọn người duyệt bước tiếp theo
              </Typography.Text>

              <Row justify={"space-between"} gutter={[8, 8]}>
                <Col xs={xs} sm={sm} md={md} xl={xl} lg={lg}>
                  <Form.Item>
                    <Input disabled={true} value={roleNguoiDuyet}></Input>
                  </Form.Item>
                </Col>

                <Col xs={xs} sm={sm} md={md} xl={xl} lg={lg}>
                  <Form.Item
                    name="nguoiDuyet"
                    rules={[{required: true, message: "Bắt buộc nhập"}]}
                  >
                    <Input></Input>
                  </Form.Item>
                </Col>
              </Row>
            </Space>
          </Form>
        ) : (
          <div style={{width: "100%", textAlign: "center"}}>
            {" "}
            <Typography.Text strong>
              Bạn có chắc chắn phê duyệt các đề nghị này?
            </Typography.Text>{" "}
          </div>
        )}
      </>
      <Row justify={"end"} style={{marginTop: 8}}>
        <Space>
          <Button onClick={closeModal}>Hủy</Button>{" "}
          <Button type="primary" onClick={submitApprove}>
            Phê duyệt
          </Button>
        </Space>
      </Row>
    </Spin>
  );
});

export default ModalApprove;
